// Generated by purs version 0.15.15
import * as Data_Show from "../Data.Show/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showBoolean);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showChar);
var show2 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var show3 = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var interpString = {
    interp: function (a) {
        return a;
    }
};
var interpFailEverythingElse = function () {
    return {
        interp: function (v) {
            return Partial_Unsafe.unsafeCrashWith("A compiler error will prevent this from running.");
        }
    };
};
var interp = function (dict) {
    return dict.interp;
};
var interpBooleanFunction = function (dictInterp) {
    var interp1 = interp(dictInterp);
    return {
        interp: function (a) {
            return function (b) {
                return interp1(a + show(b));
            };
        }
    };
};
var interpCharFunction = function (dictInterp) {
    var interp1 = interp(dictInterp);
    return {
        interp: function (a) {
            return function (b) {
                return interp1(a + show1(b));
            };
        }
    };
};
var interpIntFunction = function (dictInterp) {
    var interp1 = interp(dictInterp);
    return {
        interp: function (a) {
            return function (b) {
                return interp1(a + show2(b));
            };
        }
    };
};
var interpNumberFunction = function (dictInterp) {
    var interp1 = interp(dictInterp);
    return {
        interp: function (a) {
            return function (b) {
                return interp1(a + show3(b));
            };
        }
    };
};
var interpStringFunction = function (dictInterp) {
    var interp1 = interp(dictInterp);
    return {
        interp: function (a) {
            return function (b) {
                return interp1(a + b);
            };
        }
    };
};
var i = function (dictInterp) {
    return interp(dictInterp)("");
};
export {
    interp,
    i,
    interpString,
    interpStringFunction,
    interpBooleanFunction,
    interpIntFunction,
    interpNumberFunction,
    interpCharFunction,
    interpFailEverythingElse
};
